import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiError } from '../../api/client'
import type { SheetResult } from '../../api/settingsEaseedeskTicketTypeSheet'
import { toast } from '../../ui/notify'

export function failed(error: unknown, fallback = 'Something went wrong.'): string {
  if (error instanceof ApiError) return error.message || fallback
  return error instanceof Error ? error.message : fallback
}

/** Recititul fisei dupa orice schimbare, ca `reloadSheet()` din portal. */
export function useReload(typeId: number) {
  const client = useQueryClient()
  return () => client.invalidateQueries({ queryKey: ['settings', 'easeedesk', 'ticket_type_sheet', typeId] })
}

/** O schimbare de pe fisa: la bine reciteste, la rau spune de ce. */
export function useSheetMutation<TVars>(typeId: number, fn: (vars: TVars) => Promise<unknown>, done?: (result: unknown, vars: TVars) => void) {
  const reload = useReload(typeId)
  return useMutation({
    mutationFn: fn,
    onSuccess: (result, vars) => {
      const r = result as SheetResult | { ok?: boolean } | undefined
      if (r && 'status' in r && r.status === 'ERROR') {
        toast(r.message ?? 'Something went wrong.', 'Error', 'error')
        return
      }
      done?.(result, vars)
      void reload()
    },
    onError: (error) => toast(failed(error), 'Error', 'error'),
  })
}
